import React, { useState, useRef } from 'react';
import {
  Box,
  TextField,
  Paper,
  Typography,
  Grid,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  Divider
} from '@mui/material';
import {
  FormatBold,
  FormatItalic,
  FormatUnderlined,
  FormatStrikethrough,
  Save
} from '@mui/icons-material';
import useNotification from '../common/Notification';
import axios from 'axios';
import Cookies from 'js-cookie';
import base_url from '../../constants';
import { useNavigate } from 'react-router-dom';


const CreateWhatsappTemplate = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [selection, setSelection] = useState({ start: 0, end: 0 });
  const textFieldRef = useRef(null);
  const notify = useNotification();
  
  const navigate = useNavigate()
  const userId = Cookies.get('userId')
  const userRole = Cookies.get("userRole")
  const hasPersonal = userRole.split(",").includes("PERSONAL")
  console.log("userId extracted from Cookie", userId)

  const handleContentChange = (e) => {
    setContent(e.target.value);
    // Save current cursor position
    setSelection({
      start: e.target.selectionStart,
      end: e.target.selectionEnd
    });
  };

  const handleFormatToggle = (format) => {
    const textField = textFieldRef.current;
    if (!textField) return;

    const start = textField.selectionStart;
    const end = textField.selectionEnd;
    
    if (start === end) {
      // No text selected, apply formatting to entire content
      // applyFormattingToAll(format);

      return;

    } else {
      // Text selected, apply formatting only to selection
      applyFormattingToSelection(format, start, end);
    }
  };

// const applyFormattingToSelection = (format, start, end) => {
//   const formatMap = {
//     bold: { prefix: '*', suffix: '*' },
//     italic: { prefix: '_', suffix: '_' },
//     strikethrough: { prefix: '~', suffix: '~' },
//   };

//   const formatting = formatMap[format];
//   if (!formatting) return;

//   const selectedText = content.substring(start, end);

//   // Split into lines properly
//   const lines = selectedText.split("\n");

//   // Apply formatting per line
//   const formattedLines = lines.map(line => {
//     if (!line.trim()) return line;
    
//     // If already wrapped → remove (toggle)
//     if (
//       line.startsWith(formatting.prefix) &&
//       line.endsWith(formatting.suffix)
//     ) {
//       return line.slice(
//         formatting.prefix.length,
//         line.length - formatting.suffix.length
//       );
//     }

//     return `${formatting.prefix}${line}${formatting.suffix}`;
//   });

//   const formattedText = formattedLines.join("\n");

//   const beforeText = content.substring(0, start);
//   const afterText = content.substring(end);

//   const newContent = beforeText + formattedText + afterText;

//   setContent(newContent);

//   setTimeout(() => {
//     if (textFieldRef.current) {
//       const newPos = start + formattedText.length;
//       textFieldRef.current.focus();
//       textFieldRef.current.setSelectionRange(newPos, newPos);
//     }
//   }, 0);
// };


const applyFormattingToSelection = (format, start, end) => {
  const map = {
    bold: "*",
    italic: "_",
    strikethrough: "~"
  };

  const marker = map[format];
  if (!marker) return;

  const selectedText = content.substring(start, end);

  // Split into lines
  const lines = selectedText.split("\n");

  // Format each line independently
  const formattedLines = lines.map(line => {
    if (!line.trim()) return line;

    const isWrapped =
      line.startsWith(marker) && line.endsWith(marker);

    return isWrapped
      ? line.slice(1, -1) // remove wrap
      : marker + line + marker; // add wrap
  });

  const newText = formattedLines.join("\n");

  const updated =
    content.substring(0, start) +
    newText +
    content.substring(end);

  setContent(updated);

  // fix cursor position
  setTimeout(() => {
    textFieldRef.current.focus();
    const pos = start + newText.length;
    textFieldRef.current.setSelectionRange(pos, pos);
  }, 0);
};


  const handleTextSelection = (e) => {
    setSelection({
      start: e.target.selectionStart,
      end: e.target.selectionEnd
    });
  };

  const getFormattedContent = () => {
    return content; // Return raw content with formatting markers
  };

  const parseWhatsappFormatting = (text) => {
    if (!text) return '';
    
    // Replace newlines with <br> tags first
    let html = text.replace(/\n/g, '<br>');
    
    // Bold: *text*
    html = html.replace(/\*([^*]+)\*/g, '<strong>$1</strong>');
    
    // Italic: _text_
    html = html.replace(/_([^_]+)_/g, '<em>$1</em>');
    
    // Strikethrough: ~text~
    html = html.replace(/~([^~]+)~/g, '<del>$1</del>');
    
    // Underline: <u>text</u>
    // html = html.replace(/<u>([^<]*)<\/u>/g, '<u style="text-decoration: underline">$1</u>');
    
    return html;
  };

    const handleSubmit = async () => {
    if (!title.trim()) {
      notify("Please enter template title", "error");
      return;
    }
    if (!content.trim()) {
      notify("Please enter content", "error");
      return;
    }

    const newTemplate = {
      template_title: title,
      template: content,
    };

    try {
      await axios.post(
        base_url + "/whatsapp-template/create",
        {
          user_id: userId,
          role: hasPersonal ? "PERSONAL" : null,
          title: newTemplate.template_title,
          template: newTemplate.template,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      notify("Template created successfully", "success");
      setTitle("");
      setContent("");
      navigate("/create-template")
    } catch (error) {
      console.log(error);
      notify("Failed to create template", "error");
    }
  };

  const hasSelection = selection.start !== selection.end;


  return (
    <Box sx={{ p: 3, height: '100vh' }}>
      <Typography variant='h6'  sx={{ mb: 4, mt: 3, color : 'primary.main', width: 'fit-content', py:1, borderRadius:2, fontWeight:'bold'}}>
        Create New WhatsApp Template
      </Typography>
      
      <Grid container spacing={4} sx={{ height: 'calc(100vh - 120px)' }}>
        {/* Left Side - Form */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 3, height: '100%' }}>
            <Typography variant="h6" gutterBottom>
              Template Details
            </Typography>
            
            <TextField
              fullWidth
              label="Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              margin="normal"
              variant="outlined"
              placeholder="Enter template title..."
            />
            
            <Box sx={{ mt: 3 }}>
              <Typography variant="subtitle1" gutterBottom>
                Content
              </Typography>
              
              <TextField
                fullWidth
                multiline
                rows={6}
                value={content}
                onChange={handleContentChange}
                onSelect={handleTextSelection}
                inputRef={textFieldRef}
                variant="outlined"
                placeholder="Enter your message content... Use Enter for new lines."
                sx={{ mb: 2 }}
                inputProps={{
                  style: { whiteSpace: 'pre-wrap' } // This ensures newlines are preserved
                }}
              />
              
              {/* Formatting Buttons */}
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                <ButtonGroup variant="outlined" aria-label="text formatting">
                  <Button
                    onClick={() => handleFormatToggle('bold')}
                    color="primary"
                    disabled={!hasSelection}  
                  >
                    <FormatBold />
                  </Button>
                  <Button
                    onClick={() => handleFormatToggle('italic')}
                    color="primary"
                    disabled={!hasSelection}  
                  >
                    <FormatItalic />
                  </Button>
                  {/* <Button
                    onClick={() => handleFormatToggle('underline')}
                    color="primary"
                    disabled={!hasSelection}  
                  >
                    <FormatUnderlined />
                  </Button> */}
                  <Button
                    onClick={() => handleFormatToggle('strikethrough')}
                    color="primary"
                    disabled={!hasSelection}  
                  >
                    <FormatStrikethrough />
                  </Button>
                </ButtonGroup>
              </Box>
              
              <Typography variant="caption" color="textSecondary">
                {hasSelection 
                  ? `Formatting will be applied to selected text (${selection.end - selection.start} characters)`
                  : 'Select text to apply formatting to specific parts, or apply to all content'
                }
              </Typography>
              <Typography variant="caption" color="textSecondary" display="block">
                WhatsApp supports: *bold*, _italic_, ~strikethrough~. Press Enter for new lines.
              </Typography>
            </Box>
            
            <Box sx={{ mt: 3, p: 2, backgroundColor: '#e8f5e8', borderRadius: 1 }}>
              <Typography variant="subtitle2" gutterBottom>
                Formatted Output (Raw):
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  fontFamily: 'monospace',
                  whiteSpace: 'pre-wrap' // This preserves newlines
                }}
              >
                {getFormattedContent() || '(No content)'}
              </Typography>
            </Box>

            <Box sx={{mt:3, display:"flex", justifyContent:"flex-end"}}>
            <Button variant='contained' color='primary' startIcon={<Save/>} onClick={handleSubmit}>Save</Button>
            </Box>
          </Paper>
        </Grid>
        
        {/* Right Side - Preview */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 3, height: '100%' }}>
            <Typography variant="h6" gutterBottom>
              Preview
            </Typography>
            
            <Box sx={{ 
              backgroundColor: '#e5ddd5', 
              height: '90%', 
              borderRadius: 1,
              p: 2,
              backgroundImage: 'url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAdgAAAHYBTnsmCAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAnSURBVHic7cEBDQAAAMIg+6c2BL4mAAAAAAAAAAAAAAAAAAD4B7a4AAFj8b8zAAAAAElFTkSuQmCC")',
              display: 'flex',
              flexDirection: 'column'
            }}>
              {/* WhatsApp Header */}
              <Box sx={{ 
                backgroundColor: '#075e54', 
                color: 'white', 
                p: 2, 
                borderRadius: '10px 10px 0 0',
                display: 'flex',
                alignItems: 'center',
                gap: 2
              }}>
                <Box sx={{ 
                  width: 40, 
                  height: 40, 
                  backgroundColor: '#25d366', 
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 'bold'
                }}>
                  WA
                </Box>
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Business Account
                  </Typography>
                  <Typography variant="caption">
                    WhatsApp Business
                  </Typography>
                </Box>
              </Box>
              
              {/* Chat Area */}
              <Box sx={{ flex: 1, p: 2, overflow: 'auto' }}>
                {/* Template Message */}
                <Card sx={{ 
                  maxWidth: '70%', 
                  ml: 'auto', 
                  mb: 2,
                  backgroundColor: '#dcf8c6',
                  border: '1px solid #e5e5e5'
                }}>
                  <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                    {/* {title && (
                      <Typography 
                        variant="subtitle2" 
                        fontWeight="bold" 
                        gutterBottom
                        sx={{ color: '#075e54' }}
                      >
                        {title}
                      </Typography>
                    )} */}
                    
                    {content ? (
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          lineHeight: 1.4,
                          '& strong': { fontWeight: 'bold' },
                          '& em': { fontStyle: 'italic' },
                          '& del': { textDecoration: 'line-through' },
                          // '& u': { textDecoration: 'underline' }
                        }}
                        dangerouslySetInnerHTML={{ 
                          __html: parseWhatsappFormatting(content) 
                        }}
                      />
                    ) : (
                      <Typography variant="body2" color="textSecondary">
                        Your message will appear here...
                      </Typography>
                    )}
                    
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                      <Typography variant="caption" color="textSecondary">
                        {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
                
                {/* Info Message */}
                <Card sx={{ 
                  maxWidth: '80%', 
                  backgroundColor: 'white',
                  border: '1px solid #e5e5e5'
                }}>
                  <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                    <Typography variant="caption" color="textSecondary">
                      This is a preview of how your template will look in WhatsApp.
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
              
              {/* WhatsApp Footer */}
              <Box sx={{ 
                backgroundColor: '#f0f0f0', 
                p: 1, 
                borderRadius: '0 0 10px 10px',
                textAlign: 'center'
              }}>
                <Typography variant="caption" color="textSecondary">
                  Template message • No replies
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CreateWhatsappTemplate;